// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"213":"b9cf476d","238":"2d5ef335","455":"8c172668"}[chunkId] + ".chunk.js";
};